import client from '../client';

export const _getLocation = async (lat, long, search) => {
  const params = {
    lat,
    long,
    search: encodeURIComponent(search || 'street_address'),
  };

  const response = await client.get('services/location', params);
  const resp = await response.json();
  return resp.data;
};

export const _getLocationByZipCode = async (zipCode) => {
  const params = {
    zipCode: encodeURIComponent(zipCode),
  };

  const response = await client.get('services/location/zipcode', params);
  const resp = await response.json();
  return resp.data;
};
